import { create } from 'zustand'

interface AppState {
  user: {
    id: string | null
    region: string
    language: string
  } | null
  predictions: any[]
  actions: any[]
  setUser: (user: AppState['user']) => void
  setRegion: (region: string) => void
  setLanguage: (language: string) => void
  addPrediction: (prediction: any) => void
  addAction: (action: any) => void
}

export const useStore = create<AppState>((set) => ({
  user: null,
  predictions: [],
  actions: [],
  setUser: (user) => {
    set({ user })
    if (user) {
      localStorage.setItem('kaching-user', JSON.stringify(user))
    } else {
      localStorage.removeItem('kaching-user')
    }
  },
  setRegion: (region) => set((state) => {
    const newUser = state.user ? { ...state.user, region } : null
    if (newUser) {
      localStorage.setItem('kaching-user', JSON.stringify(newUser))
    }
    return { user: newUser }
  }),
  setLanguage: (language) => set((state) => {
    const newUser = state.user ? { ...state.user, language } : null
    if (newUser) {
      localStorage.setItem('kaching-user', JSON.stringify(newUser))
    }
    return { user: newUser }
  }),
  addPrediction: (prediction) => set((state) => ({
    predictions: [prediction, ...state.predictions].slice(0, 50),
  })),
  addAction: (action) => set((state) => ({
    actions: [action, ...state.actions].slice(0, 50),
  })),
}))

// 초기화 시 localStorage에서 사용자 정보 로드
const savedUser = localStorage.getItem('kaching-user')
if (savedUser) {
  try {
    useStore.getState().setUser(JSON.parse(savedUser))
  } catch (e) {
    console.error('Failed to load user from localStorage:', e)
  }
}

